import { InvestmentProductsByTypeResponse } from '@repo/accounts-types'
import { ApiResponse, GenericOperationState } from '@repo/core'
import { RootState } from '../../../../store/types'

export const productsByTypeDataSelectorConfig = {
  productsByTypeDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<InvestmentProductsByTypeResponse> | null> {
      return state.accounts.detail.read.productsByType
    },
  },
}
